import { Money, MoneyCurrency } from '@booking-core/domain/value_objects/money.js';
import type {
  PricingInput,
  PricingStrategy,
} from '../pricing-strategy.js';

export interface HourlyPerPersonParams {
  /** TWD per person per hour. */
  readonly amountPerPersonPerHour: number;
}

/**
 * 每人每小時。Total = amount × (min/60) × partySize，末端 Math.round。
 *
 * 不做 ceil — 呼叫端決定 billable minutes：
 *   - reservation quote：exact 窗長度（fractional hour OK）
 *   - play session：rounding policy（UnitHourTolerantPolicy 等）已 round
 *     到整小時才進來
 * 策略純按比例算。這樣 booking 的 90min → 1.5×amount 跟 play 的整點
 * billing 都走同一條 pure fn（SSOT）。
 */
export class HourlyPerPersonStrategy implements PricingStrategy {
  constructor(private readonly params: HourlyPerPersonParams) {}

  quote(input: PricingInput): Money {
    if (input.partySize <= 0) {
      return Money.zero(MoneyCurrency.TWD);
    }
    const raw =
      this.params.amountPerPersonPerHour *
      (input.billableDurationMinutes / 60) *
      input.partySize;
    return Money.of({ amount: Math.round(raw), currency: MoneyCurrency.TWD });
  }
}
